import React, { PropTypes } from 'react';
import Radium from 'radium';
import { connect } from 'react-redux';

import StyleDecorator from './components/StyleDecorator';


const mapStateToProps = (state, ownProps) => ({
	session: state.session,
	redirect: ownProps.location.query.redirect,
	variant: ownProps.location.query.variant,
});

export class LoginApp extends React.Component {

	static propTypes = {
		session: PropTypes.object.isRequired,
		dispatch: PropTypes.func,
		redirect: PropTypes.string,
		variant: PropTypes.string,
	};

	render() {
		// this causes a redirect loop in local environment, since there is no apache rewrite rule
		window.location = '/';
		return null;
	}
}

export default connect(mapStateToProps)(StyleDecorator(Radium(LoginApp)));



// WEBPACK FOOTER //
// ./src/LoginApp.js